const initialState = {
    goals:[],
    message:""
}

const actWithTeamReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SEND_ACT_WITH_TEAM":
            return{
                ...state,
                goals:action.payload.goals,
                message: action.payload.message
            }
        default:
            return {
                ...state
            }
    }
}

export default actWithTeamReducer;